'use strict';
(function(smarket, ko, $) {
  // 过滤
  var filter = {
    // 过滤文件类型
    fileType: function(ext) {
      var list = [
        {key: 'word', category: 'word'}, {key: 'docx', category: 'word'}, {key: 'doc', category: 'word'},
        {key: 'xls', category: 'excel'}, {key: 'xlsx', category: 'excel'}, {key: 'csv', category: 'excel'},
        {key: 'ppt', category: 'ppt'}, {key: 'pptx', category: 'ppt'}, {key: 'mp3', category: 'music'},
        {key: 'amr', category: 'music'}, {key: 'jpg', category: 'picture'}, {key: 'bmp', category: 'picture'},
        {key: 'gif', category: 'picture'}, {key: 'jpeg', category: 'picture'}, {key: 'psd', category: 'picture'},
        {key: 'png', category: 'picture'}, {key: 'tiff', category: 'picture'}, {key: 'svg', category: 'picture'},
        {key: 'mp4', category: 'video'}, {key: 'mpeg', category: 'video'}, {key: 'avi', category: 'video'},
        {key: 'zip', category: 'rar'}, {key: 'rar', category: 'rar'}, {key: 'zipx', category: 'rar'},
        {key: 'iso', category: 'rar'}, {key: 'bz', category: 'rar'}, {key: 'tar', category: 'rar'},
        {key: 'pdf', category: 'pdf'}, {key: '文件夹', category: 'folder'}, {key: '*', category: 'unknown'}
      ];
      return list.filter(function(item) {
        return ext === item.key || item.key === '*';
      })[0].category;
    },
    exclude: function(obj, afterFun) {
      for (var i in obj) {
        if (obj.hasOwnProperty(i) && (obj[i] === '' || obj[i] === undefined)) {
          delete obj[i];
        }
      }
      if (typeof afterFun === 'function') {
        afterFun(obj);
      }
      return obj;
    }
  };
  function getUserAgentInfo() {
    var ua = window.navigator.userAgent;
    return {
      isAndroid: !!ua.match(/(Android)/i),

      isWeChat: !!ua.match(/MicroMessenger.+?([\d.]+)/i)
    };
  }

  var weChatId, // 获取微信身份，所使用的weChatId
    unusedWeChatId, // 标明文章行为记录的实例id
    articleId = smarket.urlParams.articleId,
    articleContent,
    markCode = smarket.urlParams.markCode || '',
    fs = smarket.urlParams.fs || '',
    downloadUrl = smarket.urlParams.downloadUrl || '',
    realWeChatId,
    own = {
      session: '',
      memberId: 0,  //体系人员Id
      globalUserId: smarket.cookie.globalUserId(),
      openId: '' // 优先cookie里的，其次获取到的存到cookie里，在其次是url里带的ocode参数
    };
  var tenantId = '';
  var instanceId = '';
  var moduleId = '';
  var config = '';
  var vm = new smarket.viewModel.ArticleViewModel(smarket.urlParams.articleId);
  if(downloadUrl){
    if(getUserAgentInfo()['isWeChat']){
      $('.weChatTips').show();
    }
    else {
      $.cookie('fileSession', fs, {domain: smarket.getDomain(window.location.hostname), path: '/'});
      window.open(decodeURIComponent(downloadUrl));
    }
  }

  //全员营销模板使用
  vm.isWeChat = ko.observable(smarket.inWeChat);
  var cardUrl = smarket.urlParams.cardUrl ? smarket.urlParams.cardUrl : '';
  vm.fullMarketPageUrl = ko.observable(cardUrl);
  vm.shareCon = ko.observable({});
  vm.isShowMulti = ko.observable(true);
  vm.radioFileId = ko.observable('');
  window.addEventListener('message', function(e) {
    if (e.data.fullMarketAlertShareVal) {
      vm.shareCon(e.data.fullMarketAlertShareVal);
      $('#share-tip').show();
    }
    if (e.data == 'hide') {
      $('.fullMarketIframe').hide();
    }
  });

  vm.closeModal = function() {
    $('#share-tip').hide();
  };

  if (smarket.urlParams.marketingTaskId) {
    // 封装一下push历史记录的方法
    function pushHistory() {
      window.history.pushState('forward', null, '#');
    }

    window.addEventListener('popstate', function() {
      history.back();
      history.back();
      history.go(-1);
    }, false);
    // 在需要监听的页面执行该方法
    pushHistory();
  }

  //裂变模块选择图文加参数 全员营销模块加参数
  smarket.registerRulesListHandler(function(url, data) {
    data.markCode = smarket.urlParams.markCode;
    data.marketingSess = $.cookie('marketingSess');
    data.taskId = smarket.urlParams.marketingTaskId;
    data.browseInfo = activeRecord.browseInfo;
  }, ['/article/browse']);

  //重写获取文章信息
  // vm.get = function() {
  //   var self = this,
  //       defer = $.Deferred();
  //   smarket.api.article.get(self.articleId, 1, 1, 1, smarket.urlParams.ocode).then(function(data) {
  //     var result = data,
  //         content = result.content;
  //     if (result.result == 0) {
  //       self.init(content);
  //       defer.resolve(data);
  //     }
  //     else {
  //       defer.reject(data);
  //     }
  //   }, function(error) {
  //     defer.reject(error);
  //   });
  //   return defer.promise();
  // };

  vm.topicId = 0;

  vm.isAllowedLike = ko.observable();  //是否开启点赞
  vm.likeCount = ko.observable();  //点赞数量
  vm.canLike = ko.observable(true);  //是否可以点赞
  vm.like = function() {
    if (vm.canLike()) {
      smarket.api.article.like({
        articleId: articleId,
        globalUserId: own.globalUserId,
        openId: own.openId,
        sess: own.session,
        weChatId: unusedWeChatId,
        resolution: window.screen.width + '*' + window.screen.height
      });
      vm.likeCount(Number(vm.likeCount()) + 1);
      vm.canLike(false);
    }
  };  //点赞方法

  vm.goBack = function () {
    window.history.go(-1);
  }

  vm.fileList = ko.observableArray();  //文件列表
  vm.selectedFiles = ko.observableArray(); //选中的文件
  vm.fileSelected = [];
  vm.selectedFilesName = ko.observableArray();//选中文件的名称
  vm.wenjianleixing = ko.observableArray();//选中文件的类型
  vm.isSelectAll = ko.observable(false);  //是否全选了
  vm.selectFile = function(file) {
    file.isSelect(!file.isSelect());
    if (file.isSelect()) {
      vm.selectedFiles().push(file.fileId);
      vm.fileSelected.push(file);
      vm.selectedFilesName.push(file.name);
      vm.wenjianleixing.push(file.ext);
    } else {
      vm.selectedFiles(vm.selectedFiles().filter(function(elem) {
        return elem !== file.fileId;
      }));
    }
    vm.isSelectAll(vm.selectedFiles().length === vm.fileList().length);
    vm.canDownload(vm.selectedFiles().length > 0);
    return true;
  };  //选中文件
  vm.selectAll = function() {
    vm.isSelectAll(!vm.isSelectAll());
    var allFileId = [];
    var allFileIdName = [];
    var leixing = [];
    if (vm.isSelectAll()) {
      vm.fileList().forEach(function(data) {
        allFileId.push(data.fileId);
        allFileIdName.push(data.name);
        leixing.push(data.ext);
        data.isSelect(true);
      });
      vm.fileSelected = vm.fileList();
    } else {
      vm.fileList().forEach(function(data) {
        data.isSelect(false);
      });
      vm.fileSelected = [];
    }
    vm.selectedFiles(allFileId);
    vm.selectedFilesName(allFileIdName);
    vm.wenjianleixing(leixing);
    vm.canDownload(vm.selectedFiles().length > 0);
    return true;
  };  //选中全部
  vm.canDownload = ko.observable(false);  //是否可以下载

  vm.switchModalClose = function() {
    vm.downloadModal(!vm.downloadModal());
  };
  vm.downloadModal = ko.observable(false);  //下载弹窗显示
  vm.switchModal = function() {
    if (vm.canDownload() || vm.radioFileId()) {
      var file;
      vm.fileList().forEach(function(data) {
        if(data.fileId == vm.radioFileId()){
          file = data;
          return;
        }
      });
      if(vm.isShowMulti() || file.folderDownloadType == '0'  ){//邮件下载多选 和 邮件下载单选的
        var isNeedShow = true;
        if(vm.isShowMulti()){//多选的情况

          vm.fileSelected.forEach(function (f) {
            if(f.identity == '3' && own.session == ''){//邮件下载多选需要登录
              isNeedShow = false;
              smarket.initForm({
                identity:f.identity,
                formId:f.registerFormId,
                weChatId: weChatId,
                trackId: articleContent.trackId,
                schemaId: articleContent.schemaId,
                instanceId: articleContent.instanceId,
                attentionWeChat: weChatId,
                type: 'wap',
                extraConfig: articleContent.extraConfig,
                tenantId: vm.tenantId(),
                meetingInstanceId: articleContent.meetingInstanceId,
                meetingType: articleContent.meetingType,
                preview: true,
                moduleId: articleContent.moduleId
              },function () {
                null//
              })
            }
          })
        }
        if(file && file.folderDownloadType == '0'){ //单选的情况
          if(file.identity == '3' && own.session == ''){//邮件下载单选需要登录
            isNeedShow = false;
            smarket.initForm({
              identity:file.identity,
              formId:file.registerFormId,
              weChatId: weChatId,
              trackId: articleContent.trackId,
              schemaId: articleContent.schemaId,
              instanceId: articleContent.instanceId,
              attentionWeChat: weChatId,
              type: 'wap',
              extraConfig: articleContent.extraConfig,
              tenantId: vm.tenantId(),
              meetingInstanceId: articleContent.meetingInstanceId,
              meetingType: articleContent.meetingType,
              preview: true,
              moduleId: articleContent.moduleId
            },function () {
              //null//
            })
          }
        }
        if (!!$.cookie('user_email')) {
          vm.email($.cookie('user_email'));
          console.log('$.cookie222', $.cookie('user_email'), vm.email());
        } else {
          //获取联系人
          smarket.api.filesb.getWechat({
            tenantId: tenantId,
            weChatId: smarket.urlParams.weChatId,
            isAuthorize: 1
          }).then(function (data) {
            if (data.result == 0) {
              smarket.api.filesb.getContact({
                tenantId: tenantId,
                weChatId: data.content.bindWeChatId ? data.content.bindWeChatId : data.content.weChatId,
                openId: own.openId
              }).then(function (data) {
                if (data.result == 0) {
                  vm.email(data.content.email);
                  $.cookie('user_email', vm.email(), {path: '/', domain: ''});
                } else {
                  vm.email('');
                }
              });

            } else {
              vm.email('');
            }
          });
        }
        //vm.email('');
        vm.downloadModal(!vm.downloadModal() && isNeedShow);
      }else{ //单选直接下载
        var isNeedShow = true;

        if(file.identity == '3' && own.session == ''){
          isNeedShow = false;
          smarket.initForm({
            identity:file.identity,
            formId:file.registerFormId,
            weChatId: weChatId,
            trackId: articleContent.trackId,
            schemaId: articleContent.schemaId,
            instanceId: articleContent.instanceId,
            attentionWeChat: weChatId,
            type: 'wap',
            extraConfig: articleContent.extraConfig,
            tenantId: vm.tenantId(),
            meetingInstanceId: articleContent.meetingInstanceId,
            meetingType: articleContent.meetingType,
            preview: true,
            moduleId: articleContent.moduleId
          },function () {
            //null//
          })
        }
        if(isNeedShow) {
          //需要判断PC wap ios android 的不同情况
          var agent = getUserAgentInfo();
          if(agent.isWeChat && agent.isAndroid){
            window.location.href += '&fs=' + own.session+'&downloadUrl='+ encodeURIComponent(file.fileDownloadUrl);
          }
          else{
            window.open(file.fileDownloadUrl);
          }

        }
      }

    }
  };  //下载弹窗状态切换
  vm.email = ko.observable('');  //邮箱
  vm.errorTip = ko.observable(false);  //错误提示显示
  vm.errorTipText = ko.observable('');  //错误提示文字
  vm.Prevent = ko.observable(true);//防止多次提交
  vm.send = function() {
    if (!vm.Prevent()) {
      return;
    }
    if (vm.email() === '') {
      vm.errorTip(true);
      vm.errorTipText('请填写email');
      return false;
    } else if (!/^([a-zA-Z0-9_\.\-])+@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(vm.email())) {
      vm.errorTip(true);
      vm.errorTipText('请填写正确的邮箱');
      return false;
    } else {
      vm.errorTip(false);
    }

    function addBowerInfo(url, data) {
      if (!('sess' in data)) {
        data.sess = own.session;
      }
    }

    var urlItems = ['/file/downloadWithEmail'];
    smarket.registerRulesListHandler(addBowerInfo, urlItems);
    vm.Prevent(false);
    smarket.api.file.downloadWithEmail(vm.email(), vm.selectedFiles().length > 0 ? vm.selectedFiles() : [vm.radioFileId()], own.globalUserId, own.openId, articleId, 0,
      location.href, moduleId, articleContent.instanceId, {
        tenantId: tenantId,
        instanceId: instanceId,
        memberId: own.memberId,
        moduleId: moduleId,
        openId: own.openId,
        weChatId: unusedWeChatId,
        objInstanceId: unusedWeChatId,
        source: 'WAP'
      }).then(function(data) {
      vm.downloadTipModal(true);
      if (Number(data.result) === 0) {
        vm.Prevent(true);
        vm.fileList().forEach(function(data) {
          if (data.isSelect()) {
            //下载是否审核 1开启 0关闭
            if (data.isReview == 1) {
              vm.downloadTipTitle('申请已提交');
              vm.downloadTipContent('审核通过后可从邮件中下载');
            } else {
              vm.downloadTipTitle('已下载成功');
              vm.downloadTipContent('稍后请查看您的邮箱');
            }
          }
        });
        //vm.downloadTipTitle('已下载成功');
        //vm.downloadTipContent('稍后请查看您的邮箱');
        //for(var i=0;i<vm.selectedFiles().length;i++){
        //  activeRecord.on('browse',function(){
        //  }, {
        //    tenantId: tenantId,
        //    instanceId: instanceId,
        //    moduleId: moduleId,
        //    title: articleContent.title,
        //    session: own.session,
        //    memberId: own.memberId,
        //    summary: articleContent.summary,
        //    coverImageUrl: articleContent.shareImageUrl,
        //    url: window.location.href,
        //    openId: own.openId,
        //    weChatId: unusedWeChatId,
        //    objInstanceId: unusedWeChatId,
        //    objId:vm.selectedFiles()[i],
        //    objTitle: vm.selectedFilesName()[i]+'.'+vm.wenjianleixing()[i],
        //    actionKey: 'file_email',
        //    shareSuccessCallback: function() {
        //
        //    },
        //    shareCancelCallback: function() {
        //    }
        //  })
        //}
      } else {
        vm.downloadTipTitle('下载失败');
        vm.downloadTipContent(data.desc);
      }
      //初始化
      $.cookie('user_email', vm.email(), {path: '/', domain: ''});
      vm.switchModalClose();
      vm.isSelectAll(true);
      vm.selectAll();
    });
  };  //发送功能

  vm.downloadTipModal = ko.observable(false);  //发送后提示弹窗
  vm.downloadTipTitle = ko.observable('已下载成功');  //发送后提示弹窗文字
  vm.downloadTipContent = ko.observable('稍后请查看您的邮箱');  //下载后提示内容

  vm.isAllowedComment = ko.observable();  //是否开启点赞
  vm.comment = {};  //评论区实例

  vm.backUrl = ko.observable('');
  vm.backShow = ko.observable(false);
  //返回按钮显示不显示
  if (smarket.urlParams.back_returnUrl) {
    vm.backShow = ko.observable(true);
    vm.backUrl(decodeURIComponent(smarket.urlParams.back_returnUrl));
  } else {
    vm.backShow = ko.observable(false);
  }
  vm.backList = function() {
    window.location.href = vm.backUrl();
  };

  function showPage() {
    if (vm.isWeChat() && smarket.urlParams.marketingTaskId) {
      setTitle('任务详情');
    } else if (smarket.urlParams.pageTitle) {
      setTitle(smarket.urlParams.pageTitle);
    } else {
      if (articleContent.title) {
        setTitle(articleContent.title);
      }
    }
    $s_temp.loading.hide();
    if (!!smarket.urlParams.configId) {
      $('[loading="page"]').show();
      //smarket.template.renderByConfigId('commonArticle').done(function(config) {
      //    if (smarket.isUrl(config.formalUrl) && window.location.href.indexOf(config.formalUrl) < 0){
      //
      //    }else{
      //        // activeRecord.on('browse',function(){
      //        //     if (Number(articleContent.useLinkUrl) === 1) {
      //        //         location.href = articleContent.linkUrl;
      //        //     }
      //        // },{
      //        //     tenantId:tenantId,
      //        //     instanceId:instanceId,
      //        //     moduleId:moduleId,
      //        //     session:own.session,
      //        //     memberId:own.memberId,
      //        //     openId:own.openId,
      //        //     weChatId:unusedWeChatId,
      //        //     objId:articleId,
      //        //     objInstanceId:unusedWeChatId,
      //        //     objTitle:articleContent.title,
      //        //     actionKey:'article_browse'
      //        // });
      //        // // 浏览统计
      //        //smarket.api.article.browse(articleId, own.session, own.globalUserId, own.openId, location.href, document.referrer,
      //        //    new UAParser().getResult(), articleContent.title, unusedWeChatId, window.screen.width + '*'
      //        //    + window.screen.height).then(function() {
      //        //});
      //    }
      //});
    } else {
      $('[loading="page"]').show();
    }
    //ueditor图片背景
    var cbg = $('#editContent p[data-background]:hidden');
    if (cbg.length > 0)
      $('#editContent ').attr('style', cbg.attr('data-background'));
    setTimeout(function() {
      var editContentImages = document.getElementById('editContent').getElementsByTagName('img');
      var imagesUrls = [];
      for (var i = 0; i < editContentImages.length; i++) {
        imagesUrls.push(editContentImages[i].src);
        $(editContentImages[i]).off().on('click', function(event) {
          var previewImageConfigs = {
            current: event.currentTarget.src,
            urls: imagesUrls
          };
          window.$swxsdk.wx.previewImage(previewImageConfigs);
        });
      }
    }, 1000);

  }

  function setTitle(t) {
    document.title = t;
  }

  function checkWeChatId(weChatId1) {
    var defer = $.Deferred(),
      used = false;
    /**
     * 如果url里有ocode，就使用url里的weChatId
     * 其次通过源weChatId获取微信信息，并使用bindWeChatId
     * 源weChatId为0时，如果开启了显授权，就使用显授权的weChatId
     * 源weChatId为0且url有weChatId时，仅使用url里的weChatId
     * 如果未开启显授权，仅使用默认weChatId做分享操作
     */
    if (smarket.urlParams.ocode) { // 有ocode的情况下，应用url的weChatId
      smarket.api.wechat.getAppId(smarket.urlParams.weChatId).then(function(data) {
        var content = data.content;
        defer.resolve(content.bindWeChatId);
      });
      used = true;
    }
    if (weChatId1 && weChatId1 != 0) { // 文章为实例下的时候
      unusedWeChatId = weChatId1;
      if (!used) {
        smarket.api.wechat.getAppId(weChatId1).then(function(data) {
          var content = data.content;
          defer.resolve(content.bindWeChatId);
        });
      }
    } else if (smarket.urlParams.weChatId) { // 文章为全局下的，没有开启显授权，但是url里有weChatId
      unusedWeChatId = smarket.urlParams.weChatId;
      if (!used) {
        smarket.api.wechat.getAppId(smarket.urlParams.weChatId).then(function(data) {
          var content = data.content;
          defer.resolve(content.bindWeChatId);
        });
      }
    } else if (articleContent.authorisedType == 1) { // 文章为全局下的，并且开启了显授权
      if (weChatId1 == 0 && smarket.urlParams.weChatId) {
        unusedWeChatId = smarket.urlParams.weChatId;
      } else {
        unusedWeChatId = articleContent.authorisedWeChatId;
      }
      if (!used) {
        defer.resolve(unusedWeChatId);
      }
    } else { // 什么都没有
      unusedWeChatId = 0;
      if (!used) {
        defer.resolve(0);
      }
    }
    return defer.promise();
  }

  function initAfterPage(res) {
    smarket.Config.extend({tenantId: res.tenantId});
    own.globalUserId = smarket.cookie.globalUserId();
    vm.tenantId(res.tenantId);
    tenantId = res.tenantId;
    instanceId = res.instanceId;
    moduleId = res.moduleId;
    if (!!smarket.urlParams.configId) {
      smarket.template.renderByConfigId('article').done(function(config) {
        if ((smarket.isUrl(config.formalUrl) && config.formalUrl.indexOf(window.location.pathname) > 0) ||
          location.href.indexOf('local') > 0) {
          vm.load().then(function(data) {
            articleContent = data.content;
            realWeChatId = articleContent.weChatId;
            // tenantId= data.content.tenantId;
            articleContent.tenantId = vm.tenantId();
            articleContent.instanceId = instanceId;
            articleContent.moduleId = moduleId;
            // instanceId=data.content.instanceId;
            // moduleId=data.content.moduleId;
            // vm.likeCount(articleContent.likeCount);
            vm.isAllowedLike(Number(articleContent.isAllowedLike) === 1);  //是否开启点赞
            vm.topicId = Number(articleContent.topicId);
            vm.isAllowedComment(Number(articleContent.isAllowedComment) === 1);  //是否开启评论
            var authorisedType = articleContent.authorisedType == 1 ? 'snsapi_userinfo' : 'snsapi_base';  // 文章显授权设置

            // 获取统计信息
            vm.getDynamicInfo().then(function(caonima){
              vm.likeCount(caonima.statInfo ? caonima.statInfo.likeCount : 0);
            });

            // 判断加载文件列表
            if (!!articleContent.fileIds) {
              articleContent.fileIds = articleContent.fileIds.split('|');
            }
            if (articleContent.fileIds instanceof Array) {
              smarket.api.file.getListForWeChat(articleContent.fileIds).then(function(data) {
                var files = data.content;
                files.forEach(function(item) {
                  item.category = filter.fileType(item.ext);
                  item.isSelect = ko.observable(false);
                  if(item.folderDownloadType == '1'){//0邮件下载  1直接下载
                    vm.isShowMulti(false);//如果其中有一个位直接下载 隐藏多选下载
                  }
                });
                vm.fileList(files);
              });
            }
            return checkWeChatId(articleContent.weChatId).then(function(usedWeChatId) {
              weChatId = usedWeChatId;
              var defer = $.Deferred();
              var memberInfo = '';

              memberInfo = smarket.cookie.smarketMember(articleContent.schemaId);
              if (!memberInfo) {
                memberInfo = smarket.cookie.smarketMember(0);//不知道为什么这么写，保留
              }
              if (memberInfo) {
                own.session = memberInfo.session;
                own.memberId = memberInfo.memberInfo;
              }

              if (weChatId == 0 || weChatId == 'undefined' || weChatId == undefined) {
                memberInfo = smarket.cookie.smarketMember(articleContent.schemaId);
                if (memberInfo) {
                  own.session = memberInfo.session;
                  own.memberId = memberInfo.memberInfo;
                }

                defer.resolve();
              } else {
                //订阅号
                if (smarket.urlParams.openId) {
                  own.openId = smarket.urlParams.openId;
                  //defer.resolve();
                }
                if (smarket.inWeChat) {
                  //清除粉丝cookie
                  // for(var i in $.cookie()){  //2020.7.29 注释代码，从栏目跳转文章点击返回需要点击两次的问题
                  //   if(i.indexOf('verifyInfo')>-1){
                  //     smarket.cookie.verify.remove(i.split('_')[1]);
                  //     smarket.cookie.verifyInfo.remove(i.split('_')[1]);
                  //   }
                  // }
                  if (smarket.cookie.verify(weChatId) && smarket.cookie.verifyInfo(weChatId)) {
                    var tenkentInfo = smarket.cookie.verifyInfo(weChatId);
                    own.headimgurl = tenkentInfo.avatar ? tenkentInfo.avatar : '';
                    own.openId = tenkentInfo.providerId ? tenkentInfo.providerId : '';
                    own.nickname = tenkentInfo.nickname ? tenkentInfo.nickname : '';
                    defer.resolve();
                  } else {
                    return smarket.getUserInfoByToken(weChatId, authorisedType).then(function(data) {
                      if (data.tokenInfo) {
                        own.headimgurl = data.tokenInfo.avatar ? data.tokenInfo.avatar : '';
                        own.openId = data.tokenInfo.providerId ?
                          data.tokenInfo.providerId :
                          smarket.urlParams.openId ? smarket.urlParams.openId : '';
                        own.nickname = data.tokenInfo.nickname ? data.tokenInfo.nickname : '';
                      } else {
                        //excode过期重新授权
                        window.location.href = weChatId ?
                          window.config.weChatOauthUrl + '?weChatId=' + weChatId +
                          '&scope=' + authorisedType + '&return_url=' +
                          encodeURIComponent(smarket.removeParam(window.location.href.split('#')[0],
                            'excode', 'retCode', 'puzzleFlag', 'marketingTaskId', 'fullMarketPageUrl')) :
                          window.location.href.split('#')[0];
                      }

                      memberInfo = smarket.cookie.smarketMember(articleContent.schemaId);
                      if (memberInfo) {
                        own.session = memberInfo.session;
                        own.memberId = memberInfo.memberInfo;
                      }
                      defer.resolve();
                    }, function() {
                      defer.resolve();
                      return defer.promise();
                    });
                  }
                } else {
                  defer.resolve();
                }

                //}
              }
              return defer.promise();
            }, function() {
              var memberInfo = smarket.cookie.smarketMember(articleContent.schemaId);
              if (!memberInfo) {
                memberInfo = smarket.cookie.smarketMember(0);//不知道为什么这么写，保留
              }
              if (memberInfo) {
                own.session = memberInfo.session;
                own.memberId = memberInfo.memberInfo;
              }
            });
          }).then(function() {
            smarket.initForm({
              identity: articleContent.identity,//参与方式后来修改了获取的 api接口 里面的值变了
              weChatId: weChatId,
              formId: articleContent.registerFormId,//新的参数 换名字了
              trackId: articleContent.trackId,
              schemaId: articleContent.schemaId,
              instanceId: articleContent.instanceId,
              attentionWeChat: weChatId,
              type: 'wap',
              extraConfig: articleContent.extraConfig,
              tenantId: vm.tenantId(),
              meetingInstanceId: articleContent.meetingInstanceId,
              meetingType: articleContent.meetingType,
              preview: true,
              moduleId: articleContent.moduleId
            }, function(result, preData) {
              // 浏览统计
              if (!(Number(articleContent.useLinkUrl) === 1)) {
                showPage();
              }
              smarket.api.article.browse(articleId, own.session, own.globalUserId, own.openId, location.href,
                document.referrer,
                new UAParser().getResult(), articleContent.title, unusedWeChatId, window.screen.width + '*'
                + window.screen.height).then(function() {
                if (Number(articleContent.useLinkUrl) === 1) {
                  location.replace(articleContent.linkUrl);
                }
              });
              console.log(result);
            });

            /** 微信分享设置 */
            console.log('微信JSSDK库：', window.$swxsdk);
            var wd = (!realWeChatId || realWeChatId == '0') ? unusedWeChatId : realWeChatId;
            if(!wd || wd == '0'){
              wd = null;
            }
            var sharedurl = smarket.removeParam(articleContent.authUrl, 'return_url');
            var hurl = encodeURIComponent(smarket.removeParam(window.location.href.split('#')[0],'token', 'excode','retCode','puzzleFlag','marketingTaskId','fullMarketPageUrl'));
            sharedurl = smarket.updateParam('return_url', hurl, sharedurl);
            var sconf = {
              title: articleContent.shareTitle === '' ? articleContent.title : articleContent.shareTitle,
              desc: articleContent.shareDesc === '' ? articleContent.summary : articleContent.shareDesc,
              link: sharedurl,
              imgUrl: articleContent.shareImageRealPath ? window.location.protocol + '//' + articleContent.shareImageRealPath.split('//')[1] : ''
            };
            var isAll = Number(articleContent.shareState) === 0;
            var hideArr = isAll ? [
              'menuItem:share:appMessage',
              'menuItem:share:timeline',
              'menuItem:share:qq',
              'menuItem:share:QZone',
              'menuItem:copyUrl',
              'menuItem:share:brand',
              'menuItem:openWithQQBrowser',
              'menuItem:openWithSafari',
              'menuItem:favorite'
            ] : ['menuItem:favorite'];
            window.$swxsdk.initWxSdk({
              tenantId: tenantId,
              weChatId: wd,
              jsApiList: [
                'onMenuShareAppMessage',
                'onMenuShareTimeline',
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'hideMenuItems',
                'hideAllNonBaseMenuItem',
                'showMenuItems',
                'previewImage',
                'showAllNonBaseMenuItem'
              ],
              url: window.location.href.split('#')[0]
            });
            window.$swxsdk.on("sharer", sconf);
            window.$swxsdk.on("sharer_friends", sconf);
            window.$swxsdk.on("hideMenuList", {menuList: hideArr});
            if(isAll){
              window.$swxsdk.on("hideOptionMenu");
            }

            if (vm.isAllowedLike()) {
              // 获取更新点赞状态
              smarket.api.article.getLikeStatus({
                articleId: articleId,
                globalUserId: own.globalUserId,
                openId: own.openId,
                sess: own.session
              }).done(function(data) {
                vm.canLike(Number(data.content.canLike) === 1);
              });
            }

            if (vm.isAllowedComment() && vm.topicId !== 0) {
              vm.comment = new smarket.viewModel.CommentViewModel($.extend({}, articleContent, own, {
                subVersionId: articleId,
                cookieId: own.globalUserId,
                weChatId: weChatId,
                start: 0,
                num: 15,
                sourceWeChatId: unusedWeChatId
              }));
              vm.comment.afterSwitchCreateModalState = function(contactInfo) {
                if (!!contactInfo) {
                  contactInfo = filter.exclude(contactInfo);
                  $.extend(own, contactInfo);
                  $.cookie('own' + weChatId, own, {path: '/'});
                  $.extend(vm.comment.options, own, {
                    cookieId: own.globalUserId
                  });
                }
              };
              vm.comment.load().then(function() {
                vm.comment.isLoading(false);

                var windowScrollTimer;
                $(window).scroll(function() {
                  clearTimeout(windowScrollTimer);
                  windowScrollTimer = setTimeout(function() {
                    if (!$('.loadingMore').isVisable({offsetTop: -60}) && $('.loadingMore').is(':visible')
                      && !vm.comment.isLoadingMore()) {
                      vm.comment.loadMore();
                    }
                  }, 333);
                });
              }, function(data) {
                console.error(data.desc);
              });
            }

            ko.applyBindings(vm);
          });
        }
      });
    }
  }

  function initPage() {
    if(window.$s_temp.jsonParams){
      initAfterPage(window.$s_temp.jsonParams);
    }
    window.$s_temp.watch = function(c){
      if(c.type === 'jsonParams'){
        initAfterPage(c.data);
      }
    };

  }

  // 判断是否存在 cookieId ，执行页面初始化
  if (!smarket.cookie.globalUserId()) {
    smarket.api.account.getGlobalUserId().then(initPage);
  } else {
    initPage();

  }
})(smarket, ko, $);